'use client';

import { Theme, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { documentConfidenceLevelName } from './ladder';
import { TDocumentConfidenceLevel } from './types';

export type TDocumentConfidenceLabelProps = {
  level: TDocumentConfidenceLevel;
};

/**
 * The document confidence level, in words.
 *
 * Separate from the meter rather than part of it, because the design uses the name in two different
 * shapes: standalone beside the bars in the accordion summary row, and as the lead of the guidance
 * sentence on the check card. One component cannot be both, so the meter draws bars and this draws
 * the name.
 */
export default function DocumentConfidenceLabel({
  level,
}: Readonly<TDocumentConfidenceLabelProps>): ReactElement {
  return (
    <Typography
      variant="body2"
      sx={(t: Theme) => ({
        fontWeight: t.semantic.fontWeight.semibold,
        // The level name is one phrase and never wraps mid-way. Every placement puts it in a flex
        // row beside the meter, where it shrinks by default: in the accordion summary row it broke
        // "Substantial confidence" onto two lines with room to spare either side of it.
        whiteSpace: 'nowrap',
      })}
    >
      {documentConfidenceLevelName(level)}
    </Typography>
  );
}
